module.exports = __webpack_public_path__ + "static/media/ECOSUP-HOTELLERIE.e24c72e2.png";